// extracted by mini-css-extract-plugin
export default {"no-bullets":"RegisterForm_no-bullets__S1iel"};